import { createContext } from 'react'

const ParserContext = createContext()

export default ParserContext
